import { configSlice } from "./store/config.slice";
import {
  configApi,
  useGetConfigsQuery,
  useUpdateConfigMutation,
  useLazyGetConfigsQuery,
} from "./api/config.api";

export const { setConfigs } = configSlice.actions;

export {
  configApi,
  configSlice,
  useGetConfigsQuery,
  useLazyGetConfigsQuery,
  useUpdateConfigMutation,
};
